import { analysisConstants as constants } from '../constants';
import { authHeader, config, responseHandler } from '../helpers';

let download = require("downloadjs");

export const analysisActions = {
    selectPortfolioAnalysis,
    deselectPortfolioAnalysis,
    requestPortfolioAnalysesList,
    requestPortfolioAnalysis,
    requestNewPortfolioAnalysis,
    filterAnalysis,
    editPortfolioAnalysisName,
    editPortfolioAnalysisDescription,
    deletePortfolioAnalysis,
    exportPortfolioAnalysis
};

function deselectPortfolioAnalysis() {
    return async (dispatch) => {
        dispatch({ type: constants.DESELECT_PORTFOLIO_ANALYSIS });
    };
}

function requestPortfolioAnalysesList() {
    return async (dispatch) => {

        dispatch({ type: constants.GET_PORTFOLIO_ANALYSES_LIST_REQUEST });

        try {
            const url = config.documentUrl + '/GetListOfPortfolioAnalyses';
            const requestOptions = {
                method: 'GET',
                headers: authHeader()
            };
            const analyses = await fetch(url, requestOptions)
                .then(responseHandler.handleResponse, responseHandler.handleError);

            dispatch({ type: constants.GET_PORTFOLIO_ANALYSES_LIST_SUCCESS, analyses });
        }
        catch (exception) {
            dispatch({ type: constants.GET_PORTFOLIO_ANALYSES_LIST_FAILURE, exception });
        }
    };
}

function requestPortfolioAnalysis(id) {
    return async (dispatch) => {

        dispatch({ type: constants.GET_PORTFOLIO_ANALYSIS_REQUEST, id });

        try {
            let url = config.documentUrl + `/GetPortfolioAnalysis?id=${id}`;

            let requestOptions = {
                method: 'GET',
                headers: authHeader()
            };
            const model = await fetch(url, requestOptions).then(responseHandler.handleResponse, responseHandler.handleError);

            dispatch({ type: constants.GET_PORTFOLIO_ANALYSIS_SUCCESS, ...model });
        }
        catch (exception) {
            dispatch({ type: constants.GET_PORTFOLIO_ANALYSIS_FAILURE, exception });
        }
    };
}

function requestNewPortfolioAnalysis(name, desc, documentIds) {
    return async (dispatch) => {

        try {
            documentIds = documentIds.join(',');
            let url = config.documentUrl + `/RequestNewPortfolioAnalysis?name=${name}&desc=${desc}&documentIds=${documentIds}`;

            let requestOptions = {
                method: 'GET',
                headers: authHeader()
            };

            const taskId = await fetch(url, requestOptions)
                .then(responseHandler.handleResponse, responseHandler.handleError);

            dispatch({ type: constants.GET_PORTFOLIO_ANALYSIS_PENDING, taskId });
        }
        catch (exception) {
            dispatch({ type: constants.GET_PORTFOLIO_ANALYSIS_FAILURE, exception });
        }
    };
}

function filterAnalysis(filter) {
    return async (dispatch) => {
        dispatch({ type: constants.CHANGE_ANALYSIS_FILTER, filter });
    };
}

function selectPortfolioAnalysis(id) {
    return async (dispatch) => {
        dispatch({ type: constants.SELECT_PORTFOLIO_ANALYSIS, id });
    };
}

/***** EDIT PORTFOLIO *****/

function editPortfolioAnalysisName(id, name) {
    return async (dispatch) => {

        dispatch({ type: constants.EDIT_PORTFOLIO_ANALYSIS_NAME_REQUEST, id, name });

        try {
            const url = config.documentUrl + `/EditPortfolioAnalysisName?id=${id}&name=${name}`;
            const requestOptions = {
                method: 'GET',
                headers: authHeader()
            };
            await fetch(url, requestOptions)
                .then(responseHandler.handleResponse, responseHandler.handleError);

            dispatch({ type: constants.EDIT_PORTFOLIO_ANALYSIS_NAME_SUCCESS });
        } catch (exception) {
            dispatch({ type: constants.EDIT_PORTFOLIO_ANALYSIS_NAME_FAILURE, exception });
        }
    };
}

function editPortfolioAnalysisDescription(id, desc) {
    return async (dispatch) => {

        dispatch({ type: constants.EDIT_PORTFOLIO_ANALYSIS_DESC_REQUEST, id, description: desc });

        try {
            const url = config.documentUrl + `/EditPortfolioAnalysisDescription?id=${id}&description=${desc}`;
            const requestOptions = {
                method: 'GET',
                headers: authHeader()
            };
            await fetch(url, requestOptions)
                .then(responseHandler.handleResponse, responseHandler.handleError);

            dispatch({ type: constants.EDIT_PORTFOLIO_ANALYSIS_DESC_SUCCESS });
        } catch (exception) {
            dispatch({ type: constants.EDIT_PORTFOLIO_ANALYSIS_DESC_FAILURE, exception });
        }
    };
}


function deletePortfolioAnalysis(id) {
    return async (dispatch) => {

        dispatch({ type: constants.DELETE_PORTFOLIO_ANALYSIS_REQUEST, id });

        try {
            const url = config.documentUrl + `/DeletePortfolioAnalysis?id=${id}`;
            const requestOptions = {
                method: 'GET',
                headers: authHeader()
            };
            await fetch(url, requestOptions)
                .then(responseHandler.handleResponse, responseHandler.handleError);

            dispatch({ type: constants.DELETE_PORTFOLIO_ANALYSIS_SUCCESS, id });
        } catch (exception) {
            dispatch({ type: constants.DELETE_PORTFOLIO_ANALYSIS_FAILURE, exception });
        }
    };
}

function exportPortfolioAnalysis(id) {
    return async (dispatch) => {

        dispatch({ type: constants.EXPORT_PORTFOLIO_ANALYSIS_REQUEST, id });

        try {
            const url = config.documentUrl + `/ExportPortfolioAnalysisAsExcel?id=${id}`;
            const requestOptions = {
                method: 'GET',
                headers: authHeader()
            };
            let file = await fetch(url, requestOptions)
                .then(responseHandler.handleResponse, responseHandler.handleError);
            download(file, file.name);

            dispatch({ type: constants.EXPORT_PORTFOLIO_ANALYSIS_SUCCESS, id });
        } catch (exception) {
            dispatch({ type: constants.EXPORT_PORTFOLIO_ANALYSIS_FAILURE, exception });
        }
    };
}


// WEBPACK FOOTER //
// ./src/actions/analysis.actions.js